const Shimmer =()=>{(


    
    <div className="res-container">

    <div className="res-card">
            <img id="food-img-sch"/>
            <h3></h3>
            <p></p>
            <p></p>
            <p></p>
            <p></p>
    </div>


</div>
)};

export default Shimmer;